import React, { useEffect, useState } from "react";
import {
  Box, Button, TextField, Dialog, DialogTitle, DialogContent,
  DialogActions, CircularProgress, Typography
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { toast, ToastContainer } from "react-toastify";
import {
  fetchInternationalBannerList,
  editInternationalBanner,
  updateInternationalBanner,
  trashInternationalBanner,
} from "../../Adapters/ApiAdapter";
import "react-toastify/dist/ReactToastify.css";

const HomePageInternationalBanner = () => {
  const [bannerData, setBannerData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editItem, setEditItem] = useState(null);
  const [loadingAction, setLoadingAction] = useState(false);

  const loadData = async () => {
    try {
      const res = await fetchInternationalBannerList();
      setBannerData(res.data ? [res.data] : []);
    } catch {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleEdit = async (id) => {
    try {
      const res = await editInternationalBanner(id);
      setEditItem(res.data);
    } catch {
      toast.error("Failed to load edit data.");
    }
  };

  const handleUpdate = async () => {
    setLoadingAction(true);
    const formData = new FormData();
    formData.append("heading", editItem.heading);
    formData.append("total_icu_beds", editItem.total_icu_beds);
    formData.append("total_doctors", editItem.total_doctors);
    formData.append("emergency_care", editItem.emergency_care);
    formData.append("enquiry_now_link", editItem.enquiry_now_link);

    try {
      await updateInternationalBanner(editItem.id, formData);
      toast.success("Updated successfully.");
      setEditItem(null);
      loadData();
    } catch {
      toast.error("Failed to update.");
    } finally {
      setLoadingAction(false);
    }
  };

  const handleTrash = async (id) => {
    try {
      await trashInternationalBanner(id);
      toast.success("Deleted successfully.");
      loadData();
    } catch {
      toast.error("Failed to delete.");
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "heading", headerName: "Heading", flex: 1 },
    { field: "total_icu_beds", headerName: "ICU Beds", width: 100 },
    { field: "total_doctors", headerName: "Doctors", width: 100 },
    { field: "emergency_care", headerName: "Emergency", width: 100 },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      renderCell: (params) => (
        <Box>
          <Button size="small" onClick={() => handleEdit(params.row.id)} variant="contained">
            Edit
          </Button>
          {/* <Button
            size="small"
            variant="contained"
            color="error"
            sx={{ ml: 1 }}
            onClick={() => handleTrash(params.row.id)}
          >
            Trash
          </Button> */}
        </Box>
      ),
    },
  ];

  return (
    <Box m={2}>
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Home Page International Banner Features
      </Typography>

      <DataGrid
        rows={bannerData}
        columns={columns}
        getRowId={(row) => row.id}
        autoHeight
        loading={loading}
      />

      {editItem && (
        <Dialog open onClose={() => setEditItem(null)} fullWidth maxWidth="sm">
          <DialogTitle>Edit International Banner</DialogTitle>
          <DialogContent>
            {["heading", "total_icu_beds", "total_doctors", "emergency_care", "enquiry_now_link"].map((field) => (
              <TextField
                key={field}
                label={field.replace(/_/g, " ").toUpperCase()}
                margin="dense"
                fullWidth
                value={editItem[field]}
                onChange={(e) =>
                  setEditItem((prev) => ({ ...prev, [field]: e.target.value }))
                }
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setEditItem(null)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={handleUpdate}
              disabled={loadingAction}
            >
              {loadingAction ? <CircularProgress size={24} /> : "Update"}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default HomePageInternationalBanner;